module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/3912c847ff3e015bef3759587803c9ce.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_preview.svg
// module id = ibnS
// module chunks = 0